import {css} from '@emotion/react'
import {DqElement} from 'module/Dq/searchDq'
import React, {MouseEventHandler, useState} from 'react'
import {log} from 'common/log'
import {Star, StarBorder} from '@mui/icons-material'
import {isMemorizable} from 'module/Memo/type/Memorizable'
import {EmotionJSX} from '@emotion/react/types/jsx-namespace'

const cssMemo = css`
	font-size: 16px;
	height: 16px;
	width: 16px;
`

interface Props {
	className?: string
	dispatchMemoToggleAction?: (x?: DqElement) => void
	element: DqElement
}

export function MemoOptionIconButton(props: Props) {
	const [hover, setHover] = useState(false)
	const onClick: MouseEventHandler = (evt) => {
		evt.stopPropagation()
		evt.nativeEvent.stopImmediatePropagation()
		if (!props.dispatchMemoToggleAction) {
			log.error('missing dispatchMemoToggleAction')
			return
		}
		if (isMemorizable(props.element)) {
			props.dispatchMemoToggleAction(props.element)
		}
	}
	const isMemoActive = !!props.element.memo
	if (!isMemorizable(props.element)) return null
	let title: string
	let icon: null | EmotionJSX.Element
	if (isMemoActive) {
		title = 'Entfernen'
		icon = !hover ? <Star fontSize={'inherit'}/> : <StarBorder fontSize={'inherit'}/>
	} else {
		title = 'Eintrag merken'
		icon = !hover ? null : <Star fontSize={'inherit'}/>
	}
	return <div
		className={props.className}
		title={title}
		css={cssMemo}
		onClick={onClick}
		onMouseOver={() => setHover(true)}
		onMouseLeave={() => setHover(false)}
	>
		{icon}
	</div>
}